import React from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ModalFormId } from 'src/components/ModalForms'
import { useModalState } from 'src/Modal/ModalStateContext'
import { EditSVG } from 'src/components/Icons/Basic'
import styled from 'styled-components/macro'
import {
  ResourceWithAuthz,
  useCanPerformActionChecker,
} from 'src/app/AppAuth/AppAuth.hooks'
import { SimpleIconButton } from '../../Buttons/SimpleIconButton'

const GridColumnEditIcon = styled(EditSVG)`
  height: 16px;
  width: 16px;
  margin: 5px;
`

export const GridColumnEdit = ({
  modalId,
  capability,
  resources,
}: {
  modalId: ModalFormId
  capability: CAPABILITY
  resources?: ResourceWithAuthz[]
}): JSX.Element | null => {
  const { openModal } = useModalState()
  const canPerformAction = useCanPerformActionChecker()

  const allowed = resources
    ? resources.some((resource) => canPerformAction(capability, resource))
    : canPerformAction(capability)
  if (!allowed) {
    return null
  }

  return (
    <SimpleIconButton
      onClick={() => {
        openModal(modalId)
      }}
    >
      <GridColumnEditIcon />
    </SimpleIconButton>
  )
}
